import SEOHead from "@/components/feature/SEOHead";
import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import HotContent from "./components/HotContent";
import StatsBanner from "./components/StatsBanner";
import LatestUpdates from "./components/LatestUpdates";
import FeaturedSection from "./components/FeaturedSection";
import Footer from "@/components/feature/Footer";

export default function Home() {
  return (
    <>
      <SEOHead
        title="6789影视 | 综艺在线观看与最新综艺 | 热门搞笑真人秀免费全集"
        description="6789影视🔥综艺大全频道，最新综艺在线观看、🔍热门综艺每日更新。搞笑综艺、真人秀综艺免费全集，高清流畅不缓冲，紧跟每期精彩内容。"
        keywords="6789影视,综艺在线观看,最新综艺,热门综艺,搞笑综艺,真人秀综艺,免费综艺,综艺全集,高清综艺,每日更新综艺"
        canonicalUrl="https://6789ys.com/"
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotContent />
        <StatsBanner />
        <LatestUpdates />
        <FeaturedSection />
      </main>
      <Footer />
    </>
  );
}